import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { env } from 'process';
import { MoralisService } from 'src/app/services/moralis.service';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
declare let window: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  showConnecteWallet = true ; 
  showBuy = false;
  userAddress :  string |undefined
  userBalance = 0 ;
  queezTokenUrl : string | undefined;
  queezTokenAdress : string | undefined;
  rampUrl : string|undefined;
  buyForm : any; 
  canBuy = false; 
  amountToPay = 0 ; 
  contractInstance : any ; 
  web3:any;
  showSpinner = false; 
  constructor(public moralisService:MoralisService,
    private formBuilder: FormBuilder) {

    
    this.queezTokenUrl = environment.queezTokenUrl; 
    this.queezTokenAdress = environment.queezTokenAdress;
    this.buyForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.pattern("^[0-9]*$")]]
    });

    let user = moralisService.getMoralis().User.current();
    if (!user) {
      console.log("===Pas de user")
      this.showConnecteWallet = true;
    }
    else{
      this.showConnecteWallet = false;
      console.log(user)
     
      this.userAddress = user.get('ethAddress')
      this.getBalance()
    }

    moralisService.getMoralis().onAccountsChanged( async (accounts: any[]) => {
      console.log("===ACCOUNTS ")
      console.log(accounts)
      let newuser = accounts[0]
      if (newuser!=this.userAddress){
        //logout 
        await moralisService.getMoralis().User.logOut();

        window.location.reload();
      }
    });
    
   }

   get form(){
    return this.buyForm.controls;
  }

  async initContract(){
   
    this.web3 = await this.moralisService.getMoralis().enable();
    this.contractInstance = new this.web3.eth.Contract(this.moralisService.saleAbi,environment.contractSaleAdress);  
    console.log(this.contractInstance);
  }
  ngOnInit(): void {
  }

  calculateAmountToPay(){
    if (this.buyForm.controls.amount.valid){
      let amount = this.buyForm.value["amount"];
      this.amountToPay = amount / 4 ; 
     
    }
  }
  async onSubmit() {
    // Process checkout data here
    if (this.amountToPay>this.userBalance){
      Swal.fire({
        title: 'Error!',
        text: "You don't have enough MATIC in your wallet. Buy more",
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }
    else{
      console.warn('Your fom has been submitted', this.buyForm.value);
      let amount = this.buyForm.value["amount"];
      this.showSpinner = true; 
      try {
        console.log(amount);
        if (this.contractInstance){
          
          let valueToPay =  this.moralisService.getMoralis().Units.ETH(this.amountToPay.toString())
          console.log("valueToPay ",valueToPay);
          console.log("Amount ",amount);
          let tx = await this.contractInstance.methods.buyTokens(amount).send({value:valueToPay,from:this.userAddress});
          console.log("===Tx done");
          console.log(tx);
          console.log(window.ethereum);
          this.showSpinner = false;
          
          if (window.ethereum){
            const tokenAddress = environment.queezTokenAdress;
            const tokenSymbol = environment.queezTokenSymbol;
            const tokenDecimals = 18;
            const tokenImage = 'http://placekitten.com/200/300';
            try {
              // wasAdded is a boolean. Like any RPC method, an error may be thrown.
              const wasAdded = await window.ethereum.request({
                method: 'wallet_watchAsset',
                params: {
                  type: 'ERC20', // Initially only supports ERC20, but eventually more!
                  options: {
                    address: tokenAddress, // The address that the token is at.
                    symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
                    decimals: tokenDecimals, // The number of decimals in the token
                    image: tokenImage, // A string url of the token logo
                  },
                },
              });
              if (wasAdded) {
                //TODO : show Queeztoken bought on interface
                console.log('Thanks for your interest!');
              } else {
                console.log('Your loss!');
              }
            } catch (error) {
              console.log(error);
              
            }
          }

          Swal.fire({
            title: 'Thank you for your support!',
            text: "You should have received your Queez Token in your wallet now. If you don't see it please add it manually. Token address:"+environment.queezTokenAdress,
            icon: 'success',
            confirmButtonText: 'Ok!'
          })
         
          this.buyForm.reset(); 
          this.amountToPay=0
         
        }
      }
      catch(error){
        this.showSpinner = false;
        console.log(error);
        Swal.fire({
          title: 'Error!',
          text: "Transaction cancelled an error occured",
          icon: 'error',
          confirmButtonText: 'Sorry!'
        })
      }
  }

    // const user = new (this.moralisService.getMoralis()).User();
    // user.set("username", login);
    // user.set("password", password);
    // user.set("email", "csurbier@idevotion.fr");
    // try {
    //   await user.signUp();
    //   // Hooray! Let them use the app now.
    // } catch (error:any) {
    //   // Show the error message somewhere and let the user try again.
    //   console.log("Error: " + error.code + " " + error.message);
    // }
  }

  async logout(){
    await this.moralisService.getMoralis().User.logOut();

    window.location.reload();
  }

  getBalance(){
    this.initContract(); 
    this.rampUrl ="https://www.moonpay.com/";// "https://buy.ramp.network/?userAddress="+this.userAddress+"&swapAsset=MATIC";
   
   
        //Remove 
        this.canBuy = true; 
        this.userBalance = 100 ; 
    const options = { chain: environment.chain, address: this.userAddress}
    this.moralisService.getMoralis().Web3API.account.getNativeBalance(options).then((balance:any)=>{
      console.log(balance)
      let valeur = this.moralisService.getMoralis().Units.FromWei(Number(balance.balance).toString())
      console.log(valeur);
      this.userBalance = Number(valeur)
      console.log("Balance ",this.userBalance)
      // si balance < 0 , on propose d'acheter des MATICS...
      if (this.userBalance<0.25){
        this.canBuy = false;
 
      }
      else{
        this.canBuy=true
      }
      if (this.userBalance < 5){
        this.showBuy = true;
      
      }
    })
  
    
  }
  authenticate () {
    this.moralisService.getMoralis().authenticate()
    .then((user: any) => {
      console.log(user)
      this.showConnecteWallet = false;
      this.userAddress = user.get('ethAddress')
      
     this.getBalance()
    })
  }

  walletconnect(){
    this.moralisService.getMoralis().authenticate({ provider: "walletconnect",mobileLinks: ["metamask"]})
    .then((user: any) => {
      console.log(user)
      this.showConnecteWallet = false;
      this.userAddress = user.get('ethAddress')
     this.getBalance()
    })
  }
}
